import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { patientActions } from '_actions';
import styles from './Header.module.css';
import { ChevronRightButton, ChevronDownButton } from '_components';
import { getDateMDYY } from '_helpers'

class PatientHomePeerReviewHeader extends React.Component {

    getChevron() {
        if (this.props.visible) {
            return (<ChevronDownButton size='extra-small' className={styles.header_button} onClick={() => this.props.toggleVisibility(this.props.review.id)} />)
        } else {
            return (<ChevronRightButton size='extra-small' className={styles.header_button} onClick={() => this.props.toggleVisibility(this.props.review.id)} />)
        }
    }

    render() {
            return (
                <div className={styles.review_header}>
                    {this.getChevron()}
                    <span className={styles.header_text}>{
                        getDateMDYY(this.props.review.date)
                        + ' - ' + this.props.review.type}
                    </span>
                </div>
            );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        toggleVisibility: bindActionCreators(patientActions.togglePeerReviewVisibility, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    return {
        review: state.entities.peerReviews[ownprops.id],
        visible: state.ui.peerReviews[ownprops.id].visible
    };
}

const connectedPatientHomePeerReviewHeader = connect(mapStateToProps, mapDispatchToProps)(PatientHomePeerReviewHeader);
export { connectedPatientHomePeerReviewHeader as PatientHomePeerReviewHeader };

